export const ROW_HEIGHT = 3.5;
export const QUARTER_HEIGHT = ROW_HEIGHT / 2;
export const HEADER_WIDTH = 6.25;
// Calendar color tokens
export const GRID_BG_UNAVAILABLE = 'rgba(136, 127, 127, 0.40)'; // #887F7F at 40%
export const GRID_CELL_BORDER = '#E5E7EB';
export const AVAILABLE_BG = '#FFFFFF';
export const AVAILABLE_BORDER = '#EDEDED';
export const SELECTION_BG = 'rgba(109, 87, 188, 0.24)'; // violet 24%


